import { render } from "./ColorPicker.vue?vue&type=template&id=f04861ae&scoped=true"
import script from "./ColorPicker.vue?vue&type=script&lang=ts"
export * from "./ColorPicker.vue?vue&type=script&lang=ts"

import "./ColorPicker.vue?vue&type=style&index=0&id=f04861ae&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f04861ae"

export default script